import { Box, MenuItem, TextField, Typography } from '@mui/material';
import { BoxFC, BoxFR } from 'components/BoxCustom';
import DataGridCellExpand from 'components/DataGridCellExpand/DataGridCellExpand';
import React, { useCallback, useState, useContext, useEffect, useMemo } from 'react';
import { addSumRow, getSumColorClassName, sxSumColorClass } from 'utils/highlightSumColor';
import { columns } from './columns';
import { GlobalStateContext } from 'contexts/GlobalStateContext';
import { initFilterData } from './initData';
import { addIdForDataGrid } from 'utils';
import { branchApiNm } from 'branch/constant/branchApiNm';
import { salaryDriverColNm } from '../DriverSalary/constant';
import { DesktopDatePicker } from '@mui/x-date-pickers-pro';
import dayjs from 'dayjs';
import { alertError } from 'components/Alert';
import { jobOrderColNm } from 'constants/jobOrderConstant';
import { UserContext } from 'contexts/UserContext';


const DriverAdvancePayV2 = () => {
  const { ax } = useContext(GlobalStateContext)
  const { user } = useContext(UserContext)
  const [dataTable, setDataTable] = useState([])
  const [filterData, setFilterData] = useState({ ...initFilterData })
  const [salDte, setSalDte] = useState(dayjs().startOf("month"))

  const filteredData = useMemo(() => {
    let result = dataTable.map(row=>({...row}))
    if(filterData.DrvNm){
      result = result.filter(row=>row.DrvNm.indexOf(filterData.DrvNm)>=0)
    }
    if(filterData.PaySts === 1){
      result = result.filter(row=>row.Amnt)
    } else if(filterData.PaySts === 0){
      result = result.filter(row=>!row.Amnt)
    }

    return result
  }, [dataTable, filterData])

  const textFieldProps = useCallback((name)=>({
    sx: {width: 150},
    size: "small",
    value: filterData[name]?? "",
    onChange: (e) => setFilterData(o => ({ ...o, [name]: e.target.value })),
  }), [filterData])

  const modDataTable = useMemo(() => {
    return addSumRow({
      dataTable: dataTable,
      sumColNms: ["Amnt"],
      sumColTotal: "DrvNm"
    })
  }, [dataTable])

  const getData = useCallback((filter) => {
    if (!filter.SalDte) {
      alertError("กรุณาระบุเดือนที่ต้องการค้นหา")
      return
    }
    const salDte = filter.SalDte.startOf("month")
    const postData = {
      ...filter,
      SalDte: salDte.format("YYYY-MM-DD"),
      AptTmSt: salDte.add(-1, "month").format("YYYY-MM-16 00:00:00"),
      AptTmFn: salDte.format("YYYY-MM-15 23:59:59"),
    }
    ax.post(branchApiNm.getDriverAdvancePayV2, postData).then(value => {
      if (value.data) {
        setDataTable(addIdForDataGrid(value.data, 'DrvId'))
      }
    })
  }, [ax])

  const monthPickerProp = useMemo(() => ({
    disableMaskedInput: true,
    label: salaryDriverColNm.SalDte,
    openTo: "month",
    views: ["year", "month"],
    inputFormat: "MMMM YYYY",
    value: salDte,
    onChange: (newValue) => {
      setSalDte(newValue.startOf("month"))
      getData({ SalDte: newValue.startOf("month") })
    },
    renderInput: (params) => <TextField size="small" {...params} sx={{ width: 170 }} />,

  }), [salDte, getData])

  const handleCellEditCommit = useCallback(({ id, field, value }) => {
    const row = dataTable.find(row => row.id === id)
    let amnt = row.Amnt
    let dscp = row.Dscp
    if(field === "Amnt" && !value){
      ax.post(branchApiNm.deleteDriverPayment, {PCTrnsIds: [row.PCTrnsId]}, false).then(value=>{
        if(value.data){
          setDataTable(o=>{
            const idx = o.findIndex(row=>row.id === id)
            o[idx][field] = null
            return [...o]
          })
        }
      })
    } else {
      if(field === "Amnt"){
        amnt = value
      } else if(field === "Dscp"){
        dscp = value
      }
      const postdata = {
        AdmAccId: user.AccId,
        UsrAccId: row.DrvId,
        DrvId: row.DrvId,
        InOutTyp: "O",
        ExpId: 79,
        PCJnlId: 6,
        JobOrdId: null,
        PayTm: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        Dscp: dscp,
        Amnt: amnt,
        WhtPrct: 0,
        VatPrct: 0,
        IsOwnRcpt: 0,
        IsCmpt: 1,
        IsCost: 1,
        IsReim: 1,
        SalDte: salDte.startOf("month").format("YYYY-MM-DD"),
        getArgs: null
      }
      if (!row.PCTrnsId) {
        ax.post(branchApiNm.insertDriverAdvPay, postdata, false).then(res => {
          if (res.data) {
            setDataTable(o=>{
              const idx = o.findIndex(row=>row.id === id)
              o[idx].PCTrnsId = res.data
              o[idx][field] = value
              return [...o]
            })
          }
        })
      } else {
        postdata.PCTrnsId = row.PCTrnsId
        postdata.PCItmId = row.PCItmId
        ax.post(branchApiNm.updateDriverPaymentAmnt, postdata, false).then(res => {
          if(res.data){
            setDataTable(o=>{
              const idx = o.findIndex(row=>row.id === id)
              o[idx][field] = value
              return [...o]
            })
          }
        })
      }
    }
  }, [ax, dataTable, user.AccId, salDte])
  useEffect(() => {
    getData({ SalDte: dayjs().startOf("month") })
  }, [getData])

  return (
    <BoxFC height='100%' sx={{ position: 'relative' }}>
      <BoxFR>
        <Typography>FILTER: </Typography>
        <TextField {...textFieldProps("DrvNm")} label={jobOrderColNm.DrvNm}/>
        <TextField {...textFieldProps("PaySts")} select label="สถานะการเบิกเงิน">
          <MenuItem value={null}>ไม่ระบุ</MenuItem>
          <MenuItem value={1}>มีเงินเบิกล่วงหน้า</MenuItem>
          <MenuItem value={0}>ไม่มีเงินเบิกล่วงหน้า</MenuItem>
        </TextField>
      </BoxFR>
      <BoxFC alignSelf="center" sx={{ position: "absolute", top: 0 }}>
        <DesktopDatePicker {...monthPickerProp} />
      </BoxFC>
      <Box height='100%' sx={{ ...sxSumColorClass, mt: 1 }}>
        <DataGridCellExpand
          // checkboxSelection
          // selectionModel={selectionModel}
          // onSelectionModelChange={(newSelectionModel) => {
          //   setSelectionModel(newSelectionModel);
          // }}
          onCellEditCommit={handleCellEditCommit}
          hideFooter
          rows={filteredData}
          columns={columns}
          getRowClassName={getSumColorClassName}
          experimentalFeatures={{ rowPinning: true }}
          pinnedRows={{ bottom: [modDataTable.find(row => row.id === 0)] }}
        />
      </Box>

    </BoxFC>
  );
}

export default DriverAdvancePayV2